// extracted by mini-css-extract-plugin
export default {"card":"Card_card__qV5wE","label":"Card_label__+XcIm","value":"Card_value__d1Lnm"};